import React from 'react';
import { Redirect } from 'react-router-dom';
import Loadable from 'react-loadable';

import APP_ROUTES from '@src/app_routes';
import Loading from '@src/components/Loading';
import Shopify from '@src/containers/Shopify';
import NotFound from '@src/containers/NotFound';
import LandingPage from '@src/containers/CampaignLandingPage/LandingPage';
import SubmissionSuccess from '@src/containers/CampaignLandingPage/SubmissionSuccess';

export default [
  {
    path: APP_ROUTES.home,
    exact: true,
    component: Loadable({ loader: () => import('./pages/SignIn'), loading: Loading }),
  },
  {
    path: APP_ROUTES.contacts,
    exact: true,
    component: Loadable({
      loader: () => import('./pages/Contacts/ContactsPage'),
      loading: Loading,
    }),
  },
  {
    path: `${APP_ROUTES.campaignSubmissionlp}`,
    exact: true,
    component: Loadable({
      loader: () =>
        import('./vp-ui/pages/CampaignSubmissionLandingPage/CampaignSubmissionLandingPage'),
      loading: Loading,
    }),
  },
  {
    path: '/shopify',
    exact: true,
    component: Shopify,
  },
  {
    path: APP_ROUTES.notFound,
    exact: true,
    component: NotFound,
  },
  {
    path: '/c/:link*(/+)', // prevent trailing slash in url from breaking app
    exact: true,
    component: ({ location }) => <Redirect to={location.pathname.slice(0, -1)} />,
  },
  {
    path: APP_ROUTES.clp,
    exact: true,
    component: LandingPage,
  },
  {
    path: APP_ROUTES.clpSuccess,
    exact: true,
    component: SubmissionSuccess,
  },
  {
    path: APP_ROUTES.videoLibraries,
    exact: true,
    component: Loadable({
      loader: () => import('./vp-ui/pages/Publishing/VideoCompilationPage'),
      loading: Loading,
    }),
  },
  {
    path: APP_ROUTES.libraryEdit,
    exact: true,
    component: Loadable({
      loader: () => import('./vp-ui/pages/CompilationPage'),
      loading: Loading,
    }),
  },
  {
    path: APP_ROUTES.libraryPlayer,
    exact: true,
    component: Loadable({
      loader: () => import('./vp-ui/pages/CompilationLandingPage'),
      loading: Loading,
    }),
  },
  {
    path: APP_ROUTES.pluginsList,
    exact: true,
    component: Loadable({
      loader: () => import('./vp-ui/pages/PluginsPage/PluginsPage'),
      loading: Loading,
    }),
  },
  {
    path: APP_ROUTES.pluginEdit,
    exact: true,
    component: Loadable({ loader: () => import('./vp-ui/pages/PluginPage'), loading: Loading }),
  },
  {
    path: APP_ROUTES.campaignList,
    exact: true,
    component: Loadable({
      loader: () => import('./pages/Campaigns/CampaignsPage'),
      loading: Loading,
    }),
  },
  {
    path: APP_ROUTES.legacyCampaignEdit,
    exact: true,
    component: Loadable({ loader: () => import('./containers/Campaign'), loading: Loading }),
  },
  {
    path: APP_ROUTES.campaignEdit,
    exact: true,
    component: Loadable({
      loader: () => import('./vp-ui/containers/CampaignEditPage/CampaignEditPage'),
      loading: Loading,
    }),
  },
  {
    path: APP_ROUTES.submissionsList,
    exact: true,
    component: Loadable({
      loader: () => import('./pages/CampaignSubmissions/CampaignSubmissions'),
      loading: Loading,
    }),
  },
  {
    path: APP_ROUTES.mediaDetails,
    exact: true,
    component: Loadable({
      loader: () => import('./pages/CampaignSubmissions/CampaignSubmissions'),
      loading: Loading,
    }),
  },
  {
    path: '/media/legacy',
    exact: true,
    component: Loadable({
      loader: () => import('./containers/MediaListPage/MediaListPage'),
      loading: Loading,
    }),
  },
  {
    path: '/share/:pageType?/:mediaId/:fileName',
    exact: true,
    component: Loadable({
      loader: () => import('./containers/MediaShare/MediaShare'),
      loading: Loading,
    }),
  },
  {
    path: APP_ROUTES.organization,
    exact: true,
    component: Loadable({ loader: () => import('./containers/Organization'), loading: Loading }),
  },
  {
    path: '/insights/new',
    exact: true,
    component: Loadable({
      loader: () => import('./vp-ui/pages/InsightsNewPage'),
      loading: Loading,
    }),
  },
  {
    path: '/insights',
    exact: true,
    component: Loadable({ loader: () => import('./vp-ui/pages/InsightsPage'), loading: Loading }),
  },
  {
    path: '/insights/:conversationId',
    exact: true,
    component: Loadable({
      loader: () => import('./vp-ui/pages/InsightsConversationPage'),
      loading: Loading,
    }),
  },
  {
    path: APP_ROUTES.admin,
    exact: true,
    component: Loadable({ loader: () => import('./containers/Clients'), loading: Loading }),
  },
  {
    path: '/signup/:title?',
    exact: true,
    component: Loadable({ loader: () => import('./pages/SignUp'), loading: Loading }),
  },
  {
    path: '/plan',
    exact: true,
    component: Loadable({
      loader: () => import('./containers/SignupStepSecond'),
      loading: Loading,
    }),
  },
  {
    path: '/forgot/password',
    exact: true,
    component: Loadable({
      loader: () => import('./pages/ForgotPassword'),
      loading: Loading,
    }),
  },
  {
    path: '/reset/password/:token',
    exact: true,
    component: Loadable({
      loader: () => import('./pages/ResetPassword'),
      loading: Loading,
    }),
  },
  {
    path: '/videos',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Videos'), loading: Loading }),
  },
  {
    path: '/videos/:uuid',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Videos'), loading: Loading }),
  },
  {
    path: '/campaign/videos/:filterId',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Videos'), loading: Loading }),
  },
  {
    path: '/plugin/:uuid',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Plugin'), loading: Loading }),
  },
  {
    path: APP_ROUTES.billing,
    exact: true,
    component: Loadable({
      loader: () => import('./vp-ui/containers/BillingContainer'),
      loading: Loading,
    }),
  },
  {
    path: APP_ROUTES.settings,
    exact: true,
    component: Loadable({ loader: () => import('./containers/Settings'), loading: Loading }),
  },
  {
    path: APP_ROUTES.newAdminPanel,
    exact: true,
    component: Loadable({
      loader: () => import('./pages/AdminPanel/AdminPanel'),
      loading: Loading,
    }),
  },
  {
    path: APP_ROUTES.changePassword,
    exact: true,
    component: Loadable({ loader: () => import('./containers/ChangePassword'), loading: Loading }),
  },
  {
    path: '/:id',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Splash/Splash'), loading: Loading }),
  },
  {
    path: '/view/:id',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Splash/Splash'), loading: Loading }),
  },
  {
    path: '/v/:fileName',
    exact: true,
    component: Loadable({ loader: () => import('./containers/Testimony'), loading: Loading }),
  },
  {
    path: '*',
    exact: true,
    component: () => <Redirect to={APP_ROUTES.notFound} />,
  },
];



// WEBPACK FOOTER //
// ./src/routes.js